export default {
  name: 'Witaj Świecie',
  text: 'Witaj Świecie!\n\nKliknąłeś tutaj: {{x}}, {{y}}',
  buttons: [
    {
      title: "Powiedz 'Witaj Świecie'"
    }
  ]
}